import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import AuthShell, { Field } from "./AuthShell";
import { useAuth, homeFor } from "../context/AuthContext";
import { errMsg } from "../lib/api";

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ business_name: "", location: "", category: "", name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={homeFor(user)} replace />;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register({ ...form, category: form.category || null, location: form.location || null });
      toast.success("Account created! Activate your subscription to get your QR code.");
      navigate("/dashboard");
    } catch (err) {
      setError(errMsg(err));
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your account" subtitle="First month free for new customers, then $29.99/month per location. All locations under one login."
      footer={<>Already have an account? <Link to="/login" className="font-semibold text-[#2F5D4A] hover:underline" data-testid="register-to-login-link">Log in</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="business-register-form">
        <Field label="Business name" required minLength={2} value={form.business_name} onChange={set("business_name")} data-testid="register-business-name-input" placeholder="e.g. Corner Bakery" />
        <Field label="Location / neighborhood" optional value={form.location} onChange={set("location")} data-testid="register-location-input" placeholder="e.g. Ballard, Seattle" />
        <Field label="Business type" optional value={form.category} onChange={set("category")} data-testid="register-category-input" placeholder="Café, salon, gym…" />
        <Field label="Your name" required value={form.name} onChange={set("name")} data-testid="register-name-input" autoComplete="name" />
        <Field label="Email" type="email" required value={form.email} onChange={set("email")} data-testid="register-email-input" autoComplete="email" />
        <Field label="Password" type="password" required minLength={6} value={form.password} onChange={set("password")} data-testid="register-password-input" autoComplete="new-password" placeholder="At least 6 characters" />
        {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl px-3 py-2" data-testid="register-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center !py-3" data-testid="register-submit-button">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Continue"}
        </button>
        <p className="text-xs text-[#778580]">Low-rating alerts will be sent to this email.</p>
      </form>
    </AuthShell>
  );
}
